<template>
  <div class="login_bimg">
    <div class="content">
      <div class="content_header">
        <div class="content-box-div">
          <div class="content-box-title">
            <img src="@static/img/title2.png" v-if="!config.isMyself" />
          </div>
          <el-divider></el-divider>
        </div>
      </div>
      <div class="content_left_bimg">
        <img src="../../static/img/login.png" />
      </div>

      <div class="content_right_login">
        <!-- <template> -->

        <el-row :span="24">
          <el-col :span="1">
            <el-divider direction="vertical"></el-divider>
          </el-col>
          <el-col :span="11">
            <div>
              <!-- <el-tabs v-model="activeName"> -->
              <!-- <el-tab-pane name="userlogin"> -->
              <span slot="label" class="fontClass">密码登录</span>
              <input
                style="
                  margin-top: 10px;
                  box-shadow: inset 0 0 0 1000px #ffffff !important;
                "
                placeholder="用户名"
                v-model="userName"
                :class="Inputactive1"
                @focus="Inputactive1 = 'Inputactive_vsited'"
                @blur="Inputactive1 = ''"
              />
              <input
                style="box-shadow: inset 0 0 0 1000px #ffffff !important"
                type="password"
                placeholder="密码"
                @keyup.enter="login"
                v-model="password"
                :class="Inputactive"
                @focus="Inputactive = 'Inputactive_vsited'"
                @blur="Inputactive = ''"
                autocomplete="off"
              />
              <input
                v-if="showValidateCode"
                placeholder="验证码"
                @keyup.enter="login"
                v-model="validateCode"
                :class="Inputactive2"
                @focus="Inputactive2 = 'Inputactive_vsited'"
                @blur="Inputactive2 = ''"
                autocomplete="off"
                style="width: 50%; display: inline-block"
              />
              <img v-if="showValidateCode" :src="validateCodeBase64" style="position: relative; top: 15px; left: 10px" @click="getValidateCodeImg()" />
              <div v-else style="height: 45px"></div>
              <div style="height: 14px"></div>
              <el-checkbox-group v-if="false" v-model="checkedItem" style="line-height: 65px">
                <el-checkbox label="rememberpwd" style="vertical-align: middle; width: 15px; margin-left: 15px">记住密码 </el-checkbox>
                <el-checkbox label="autologin" style="vertical-align: middle; width: 15px; margin-left: 60px">自动登录 </el-checkbox>
              </el-checkbox-group>
              <el-button :class="btnClass" @click.native="login" round:loading="isBtnLoading"> 登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
              <a href v-if="false">忘记密码?</a>
            </div>
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical"></el-divider>
          </el-col>
          <el-col :span="11">
            <div>
              <!--</el-tab-pane
            >
            <el-tab-pane name="wechatlogin"> -->
              <span slot="label" class="fontClass" v-if="false">扫码登录</span>
              <!-- v-if="showWeChat" -->
              <div class="weChatLoginForm" v-if="false">
                <div id="wxbox">
                  <!-- 添加自己的form 内容 -->
                  <wxlogin
                    :state="weChatState"
                    :appid="weChatAPPID"
                    :scope="weChatScope"
                    :theme="'black'"
                    :redirect_uri="encodeURIComponent(weChatRedirectURL)"
                    :href="
                      'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKICBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5xcmNvZGUgewogIGJvcmRlcjogbm9uZTsKICB3aWR0aDogMTIwcHg7CiAgaGVpZ2h0OiAxMjBweDsKICBtYXJnaW4tdG9wOiA1cHg7Cn0KLmltcG93ZXJCb3ggLnN0YXR1c3sKICBkaXNwbGF5OmlubGluZQp9Ci5pbXBvd2VyQm94IC5zdGF0dXNfdHh0ewogIHBhZGRpbmctdG9wOiAyMHB4Owp9'
                    "
                    rel="external nofollow"
                  >
                  </wxlogin>
                </div>
                <div class="angle angle-left-top"></div>
                <div class="angle angle-left-bottom"></div>
                <div class="angle angle-right-top"></div>
                <div class="angle angle-right-bottom"></div>
                <div class="weChatInfo" v-if="false">
                  <p>请使用<span style="color: #32cd32">微信</span>扫描二维码登录</p>
                </div>
                <div class="weChatInfoName" v-if="false">
                  <p>“XXX平台”</p>
                </div>
              </div>

              <!-- </el-tab-pane>
          </el-tabs> -->
              <!-- </template> -->
            </div>
          </el-col>
        </el-row>
      </div>
      <!--添加弹出框-->
      <PasswordDialog
        ref="OpenDialog"
        v-bind:dialogTitle="dialogTitle"
        v-bind:dialogVisible="showDialog"
        v-bind:userName="userName"
        v-bind:promptInfo="promptInfo"
        v-on:dialogClose="dialogClose($event)"
      >
      </PasswordDialog>
      <TipMsgDialog :userOptions="tipOptions" @tipMsgOK="tigMsgInfo()" @tipMsgClose="tipMsgCancel()" @tipMsgCancel="tipMsgCancel()" v-if="tipOptions.visible"></TipMsgDialog>
    </div>
    <div
      style="
        text-align: center;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 30px;
        color: white;
      "
    >
      备案号：琼ICP备2025058435号-5
    </div>
  </div>
</template>

<script>
import PasswordDialog from "./password";
import { InitAll } from "@/js/DropDownList.js";
import wxlogin from "vue-wxlogin";
//读取敏感词配置文件
// import { sensitiveWordsArray } from '@/js/globalConfig.js';
export default {
  data() {
    return {
      activeName: "userlogin",
      userType: 0,
      OwnedStationCode: "",
      showDialog: false,
      tipOptions: {
        showType: 0,
        visible: false,
        showDesp: true,
        btnTitle: "确 定",
        msg: "是否删除此条数据？",
        desp: "删除后不可恢复。",
        showCancelBtn: true,
      },
      tipFlag: 0,
      dialogTitle: "",
      bg: {},
      rememberPassword: false,
      autologin: false,
      userName: "",
      password: "",
      validateCode: "",
      Inputactive: "",
      Inputactive1: "",
      Inputactive2: "",
      promptInfo: "",
      loading: null,
      btnClass: "login_btn login_btn_color",
      //图片验证码src
      validateCodeBase64: "",
      //客户端uuid，用于判断验证码
      clientUUID: "",
      weChatAPPID: "",
      weChatRedirectURL: "",
      weChatState: "",
      weChatScope: "",
      dialogVisible: false,
      weChatToken: "",
      weChatUserInfo: null,
      weChatUserInfoSelected: "",
      showValidateCode: true,
      showWeChat: false,

      config: {
        isMyself: true, // 默认值
      },
    };
  },
  mounted() {},
  beforeCreate: function() {},
  created() {
    //生成客户端uuid
    this.clientUUID = this.rnd(1000000000, 9999999999);
    //获取验证码base64图片
    this.getValidateCodeImg();

    fetch("/setting.json?t=" + new Date().getTime())
      .then(response => response.json())
      .then(data => {
        this.config = data;
      })
      .catch(error => {
        console.error("Error loading config:", error);
      });
  },
  beforeDestroy: function() {
    document.onkeydown = function(e) {};
  },
  components: {
    PasswordDialog: PasswordDialog,
    wxlogin: wxlogin,
  },
  methods: {
    getWeChatInfo() {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/WeChatLogin/GetWeChatSettingInfo", {})
          .then(res => {
            if (res.data.Code == "10000") {
              this.weChatAPPID = res.data.Data.AppId;
              this.weChatRedirectURL = res.data.Data.Redirect_Uri;
              this.weChatState = res.data.Data.State;
              this.weChatScope = res.data.Data.Scope;
              resolve();
            } else {
              reject();
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //获取验证码图片
    getValidateCodeImg() {
      this.$axios
        .post("/Login/GetValidateImg", {
          uuid: this.clientUUID,
        })
        .then(res => {
          this.validateCodeBase64 = "data:image;base64," + res.data.Data;
        });
    },
    tigMsgInfo: function() {
      this.tipOptions.visible = false;
      if (this.tipOptions.showCancelBtn == true) {
        if (this.tipFlag == 1) {
          this.dialogTitle = "修改密码";
          this.promptInfo = "";
          this.showDialog = true;
          this.$refs.OpenDialog.getPasswordRule();
        }
      }
    },
    tipMsgCancel: function() {
      this.tipOptions.visible = false;
      if (this.tipFlag == 1) {
        this.getAuthToken();
      }
    },
    dialogClose(visible) {
      this.showDialog = visible;
    },
    login() {
      //按钮灰色不能点击
      if (this.btnClass == "login_btn login_btn_color") {
        return;
      }
      if (this.showValidateCode && !this.validateCode) {
        this.$message.error("请输入验证码！");
        return;
      }
      if (!this.userName) {
        this.$message.error("请输入用户名！");
        return;
      } else if (!this.password) {
        this.$message.error("请输入密码！");
        return;
      } else {
        this.loading = this.$loading({
          lock: true,
          text: "正在登录...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.loginProcess();
        // this.rememberPasswordAndAutoLogin();
      }
    },
    loginProcess() {
      this.loginChecker()
        .then(() => {
          return this.getAuthToken();
        })
        .then(() => {
          return this.getUserInfo();
        })
        .then(() => {
          //进入主界面,this.$router.push的返回值是promise
          //可能出现动态路由未拿到name的情况
          return this.$router.push({ name: "平台主页" });
        })
        .catch(err => {
          this.$message.error(err);
        })
        .finally(() => {
          if (this.loading) this.loading.close();
        });
    },
    loginChecker() {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/Login/LoginCheck", {
            username: this.userName,
            password: this.password,
            validateCode: this.validateCode,
            uuid: this.clientUUID,
          })
          .then(res => {
            //检查
            if (res.data.Code == "10000") {
              resolve();
            } else {
              if (this.loading) this.loading.close();
              this.validateCode = "";
              this.getValidateCodeImg();
              this.$message.error(res.data.Message);
            }
          })
          .catch(err => {
            if (this.loading) this.loading.close();
            reject("登录失败");
            if (err.response.status == undefined || err.response.status == null) {
              this.$message.error("服务端连接错误！");
            } else if (err.response.status == 504) {
              this.$message.error("网络连接超时，请检查网络连接是否异常！");
            } else {
              this.$message.error("服务端错误！");
            }
          });
      });
    },
    getAuthToken() {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/OAuth/Token", {
            grant_type: "password",
            Username: this.userName,
            Password: this.password,
          })
          .then(async res => {
            //获取用户信息
            await this.$store.dispatch("user/savetoken", res.data.access_token);
            await this.$store.dispatch("user/saveretoken", res.data.refresh_token);
            resolve();
          })
          .catch(async err => {
            if (this.loading) this.loading.close();
            if (err.response.status == undefined || err.response.status == null) {
              this.$message.error("服务端连接错误！");
            } else if (err.response.status == 504) {
              this.$message.error("网络连接超时，请检查网络连接是否异常！");
            } else {
              this.$message.error("用户名密码错误，或该账号已被禁用");
              await this.$store.dispatch("user/removetoken");
              await this.$store.dispatch("user/removeretoken");
            }
            reject();
          });
      });
    },
    getUserInfo() {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/Login/GetLoginUser", {})
          .then(async res => {
            if (res.data.Code == "10000") {
              await this.$store.dispatch("user/saveuser", res.data.Data);
              this.userType = res.data.Data.UserType;
              this.OwnedStationCode = res.data.Data.OwnedStationCode;
              this.OwnedDriverSchoolCode = res.data.Data.OwnedDriverSchoolCode;
              //加载下拉菜单项，存入store
              await InitAll(this.userType, this.OwnedStationCode, this.OwnedDriverSchoolCode);
              //sensitiveWordsArray();
              resolve();
            } else {
              await this.$store.dispatch("user/removetoken");
              await this.$store.dispatch("user/removeretoken");
              await this.$store.dispatch("user/removeuser");
              // this.$message.error(res.data.msg);
              reject("登录失败");
            }
          })
          .catch(async err => {
            if (this.loading) this.loading.close();
            if (err.response.status == undefined || err.response.status == null) {
              this.$message.error("服务端连接错误！");
            } else if (err.response.status == 504) {
              this.$message.error("网络连接超时，请检查网络连接是否异常！");
            } else {
              this.$message.error("获取用户信息错误！");
              await this.$store.dispatch("user/removetoken");
              await this.$store.dispatch("user/removeretoken");
              await this.$store.dispatch("user/removeuser");
            }
            reject(err);
          });
      });
    },
    rnd(n, m) {
      var random = Math.floor(Math.random() * (m - n + 1) + n);
      return random;
    },
  },
  watch: {
    userName: {
      handler: function() {
        if (this.userName != "" && this.password != "" && this.validateCode != "") {
          this.btnClass = "login_btn login_btn_color_focus";
        } else {
          this.btnClass = "login_btn login_btn_color";
        }
      },
    },
    password: {
      handler: function() {
        if (this.userName != "" && this.password != "" && this.validateCode != "") {
          this.btnClass = "login_btn login_btn_color_focus";
        } else {
          this.btnClass = "login_btn login_btn_color";
        }
      },
    },
    validateCode: {
      handler: function() {
        if (this.userName != "" && this.password != "" && this.validateCode != "") {
          this.btnClass = "login_btn login_btn_color_focus";
        } else {
          this.btnClass = "login_btn login_btn_color";
        }
      },
    },
  },
};
</script>

<style scoped>
input,
button {
  font-family: "Microsoft Yahei", Helvetica, Arial, "sans-serif";
}
body {
  color: #555;
  font-family: "Microsoft Yahei", Helvetica, Arial, "sans-serif" !important;
}

.content-box-div span {
  width: 14px;
  height: 14px;
  display: block;
  border-radius: 100%;
  background: #ffbf05;
  margin-bottom: 15px;
}
.content-box-div {
  padding: 20px;
}
.content-box-title {
  font-size: 24px;
  font-weight: bold;
  color: rgb(0, 0, 0);
  line-height: 28px;
  margin-top: 10px;
  padding-left: 10px;
}
.Inputactive_vsited {
  border-bottom: 2px solid #4c85ff !important;
  color: #4c85ff;
}
a {
  font-size: 14px;
  color: #666;
  position: relative;
  bottom: -60px;
  text-decoration: none;
}
.content {
  background-color: rgba(255, 255, 255, 255);
  width: 950px;
  height: 453px;
  margin: auto;
  margin-top: 12%;
  border-radius: 16px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.login_bimg {
  background-image: url(../assets/login_bgnew.jpg);
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.content_header {
  height: 50px;
  width: 100%;
}
.content-box-img {
  float: right;
  margin-top: -25px;
}
.content_left_bimg {
  /* background-image: url(../assets/login_left_img.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;*/
  display: inline-block;
  height: 100%;
  width: 226px;
  padding-top: 90px;
  padding-left: 40px;
}
.content_left_bimg img {
  height: 200px;
}
.content_right_login {
  position: absolute;
  display: inline-block;
  margin-left: 60px;
  margin-right: 96px;
  padding-top: 80px;
  width: 570px;
  height: 638px;
}
.content_right_login #tit {
  display: block;
  font-size: 24px;
  padding-bottom: 20px;
}
.content_right_login input {
  padding-left: 0px;
  font-size: 16px;
  border: 0 none;
  border-bottom: 2px solid #b4bac2;
  width: 220px;
  height: 52px;
  background-color: transparent;
}
.login_btn {
  width: 230px;
  height: 34px;
  border-radius: 38px;
}
.login_btn_color {
  background: #c1d1de;
  border: 1px solid #b1c0cc;
  color: #fff;
}
/*.login_btn_color:hover,
.login_btn_color:focus {
  background: #4c85ff;
  border: 1px solid #4c85ff;
  color: #fff;
}*/
.login_btn_color_focus {
  background: #4c85ff;
  border: 1px solid #4c85ff;
  color: #fff;
}
.login_input {
  margin-top: 10px;
}
.login_input:-internal-autofill-selected {
  background-color: green !important;
}

.fontClass {
  opacity: 1;
  font-size: 18px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 12px;
  letter-spacing: 0px;
}

.wechatChoose {
  margin-top: 20vh;
}
.wechatClass {
  font-size: 18px;
}
.el-divider--vertical {
  display: inline-block;
  width: 1px;
  height: 220px;
  margin: 0 8px;
  vertical-align: middle;
  position: relative;
}
#chooseUser >>> .el-dialog__header {
  display: none;
}
#chooseUser >>> .el-dialog__body {
  border-radius: 22px;
  background: rgba(244, 247, 245, 0.5);
  padding: 30px 30px 30px 30px !important;
}
#chooseUser >>> .el-dialog__footer {
  display: none;
}
#chooseUser >>> .User {
  padding: 0 !important;
}

/* .slick-slide,
.slick-active div:nth-child(0) {
  padding: 0px 20px;
} */

#chooseUser >>> .image {
  width: 100%;
  display: block;
  padding-top: 14px;
  /* border-right: #ff66ff thin solid;
  border-top: #ff66ff thin solid;
  border-left: #ff66ff thin solid;
  border-bottom: #ff66ff thin solid; */
}
#chooseUser >>> .userInfo {
  font-size: 20px;
  padding-top: 100px;
  text-align: center;
}
#chooseUser >>> .userType {
  font-size: 20px;
  padding-top: 10px;
  text-align: center;
}

#chooseUser >>> .slick-prev:before {
  color: black;
}

#chooseUser >>> .slick-next:before {
  color: black;
}

.content >>> .el-dialog {
  border-radius: 22px !important;
}

.weChatLoginForm {
  padding-top: 20px;
}
.angle {
  position: absolute;
  width: 20px;
  height: 20px;
}

.angle-left-top {
  top: 40px;
  left: 390px;
  border-left: 2px solid rgb(162 155 155);
  border-top: 2px solid rgb(162 155 155);
}

.angle-right-top {
  top: 40px;
  right: 45px;
  border-right: 2px solid rgb(162 155 155);
  border-top: 2px solid rgb(162 155 155);
}

.angle-left-bottom {
  top: 150px;
  left: 390px;
  border-bottom: 2px solid rgb(162 155 155);
  border-left: 2px solid rgb(162 155 155);
}

.angle-right-bottom {
  top: 150px;
  right: 45px;
  border-right: 2px solid rgb(162 155 155);
  border-bottom: 2px solid rgb(162 155 155);
}
.weChatInfo {
  text-align: center;
  padding-left: 35px;
  opacity: 1;
  font-size: 14px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  text-align: center;
  color: #000000;
  line-height: 12px;
  letter-spacing: 0px;
}
.weChatInfoName {
  text-align: center;
  padding-left: 35px;
  padding-top: 10px;
  opacity: 1;
  font-size: 14px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  text-align: center;
  color: #b1b1b3;
  line-height: 12px;
  letter-spacing: 0px;
}
</style>
<style>
.slick-initialized .slick-slide[data-v-e4caeaf8] div:nth-child(1) {
  padding: 0px 20px;
}

#wxbox {
  width: 180px;
  height: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue